import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PMActions";
import * as api from "../../api/plannedMaintenanceApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMaintenanceType() {
    try {
        const { data } = yield api.getMaintenanceType();
        yield put(actions.setMaintenanceType(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceType(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPMGetOrderDetailById(action) {
    try {
        const { data } = yield api.getPMGetOrderDetailById(action.payload.id);
        yield put(actions.setPMGetOrderDetailById({ data, showDates: action.payload.showDates } || undefined));
    } catch (error) {
        yield put(actions.setPMGetOrderDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postPMCreateOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postPMCreateOrder(action.payload);
        yield put(actions.postPMCreateOrderSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.postPMCreateOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postPMUpdateOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postPMUpdateOrder(action.payload);
        yield put(actions.postPMUpdateOrderSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.postPMUpdateOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPMGetOrderFiles(action) {
    try {
        const { data } = yield api.getPMGetOrderFiles(action.payload);
        yield put(actions.setPMGetOrderFiles(data || undefined));
    } catch (error) {
        yield put(actions.setPMGetOrderFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postPMAddFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postPMAddFile(action.payload);
        yield put(actions.postPMAddFileSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.postPMAddFileSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deletePMOrder(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deletePMOrder(action.payload);
        yield put(actions.deletePMOrderSuccess(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.deletePMOrderSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPMOrderList(action) {
    try {
        const { data } = yield api.getPMOrderList(action.payload);
        yield put(actions.setPMOrderList(data || undefined));
    } catch (error) {
        yield put(actions.setPMOrderList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPMOrderListPage(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPMOrderListPage(action.payload);
        yield put(actions.setPMOrderListPage(data || undefined));
    } catch (error) {
        yield put(actions.setPMOrderListPage(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedCheckItemGroupsById(action) {
    try {
        const { data } = yield api.getPlannedCheckItemGroupsById(action.payload);
        yield put(actions.setPlannedCheckItemGroupsById(data || undefined));
    } catch (error) {
        yield put(actions.setPlannedCheckItemGroupsById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedCheckItemsForTask(action) {
    try {
        const { data } = yield api.getPlannedCheckItemsForTask(action.payload);
        yield put(actions.setPlannedCheckItemsForTask(data || undefined));
    } catch (error) {
        yield put(actions.setPlannedCheckItemsForTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* putPlannedCheckItemsForTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.putPlannedCheckItemsForTask(action.payload);
        yield put(actions.setPlannedCheckItemsForTask(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setPlannedCheckItemsForTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_AREAS, getAreaList);
    yield takeEvery(actions.Types.GET_MAINTENANCE_TYPE, getMaintenanceType);
    yield takeEvery(actions.Types.GET_PM_ORDER_DETAIL_BY_ID, getPMGetOrderDetailById);
    yield takeEvery(actions.Types.PM_CREATE_ORDER, postPMCreateOrder);
    yield takeEvery(actions.Types.PM_UPDATE_ORDER, postPMUpdateOrder);
    yield takeEvery(actions.Types.GET_PM_ORDER_FILES, getPMGetOrderFiles);
    yield takeEvery(actions.Types.POST_PM_ADD_FILES, postPMAddFile);
    yield takeEvery(actions.Types.DELETE_PM_ORDER, deletePMOrder);
    yield takeEvery(actions.Types.GET_PM_ORDER_LIST, getPMOrderList);
    yield takeEvery(actions.Types.GET_PM_ORDER_LIST_PAGE, getPMOrderListPage);
    yield takeEvery(actions.Types.GET_PLANNED_CHECKITEMGROUPS_BY_ORDERID, getPlannedCheckItemGroupsById);
    yield takeEvery(actions.Types.GET_PLANNED_CHECKITEMS_FOR_TASK, getPlannedCheckItemsForTask);
    yield takeEvery(actions.Types.PUT_PLANNED_CHECKITEMS_FOR_TASK, putPlannedCheckItemsForTask);
}

const PMSagas = [fork(watchAll)];

export default PMSagas;
